import { OrganizationRef } from "../../src/api/organizations/types/OrganizationRef";
import { getDocumentData } from "../../src/helpers/index";

export default async function getOrganization({ api, env }, { organizationId }) {
	if (api.convertFromLiveToStage) {
		const organization = await getDocumentData(api.stage.db.collection("organizations").doc(organizationId));
		return OrganizationRef.parse(organization);
	}
	const organization = await getDocumentData(api[env].db.collection("organizations").doc(organizationId));
	return OrganizationRef.parse(organization);
}
